module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Elenco persone per riconoscimento"}}')
  delete Component.options._Ctor
}
